module.exports = __webpack_public_path__ + "img/daishenhe.c1e730f1.png";